<template>
  <div class="guide-wrap" v-if="configure && featureList">
    <div class="steps">
      <input-room-id :configure="configure"></input-room-id>
      <account-login
        :isGuide="true"
        :isCloud="isCloud()"
        :configure="configure"
        :roomId="
          configure.global.liveRoomName_config
            ? configure.global.liveRoomUrl
            : ''
        "
        :ticket="ticket"
        ref="accountlogin"
      ></account-login>
    </div>
    <div class="bottom-actions">
      <button
        class="btn-next button"
        :class="
          configure.global.liveRoomUrl && (cloud.user || !isCloud())
            ? ''
            : 'disabled'
        "
        @click="
          configure.global.liveRoomUrl && (cloud.user || !isCloud())
            ? save()
            : ''
        "
      >
        {{ user.activated ? "下一步" : "完成" }}
      </button>
    </div>
  </div>
</template>

<script>
import {
  userInfo,
  getConfig,
  getFeatureList,
  checkCloudLogin,
  getCloudStatus,
  cloudLogout,
  cloudLogin,
  getCloudQrCode,
  updateConfig,
  getRoomName,
  passwordLogin,
  smsImgInfo,
  smsImgVerify,
  setGuide,
} from "@/api/index";
import { deepObjectMerge } from "@/utils/object";
import { Message } from "element-ui";
import countryOptions from "@/assets/js/countryOptions.json";
import { mapState, mapActions } from "vuex";
import accountLogin from "@/components/accountLogin";
import inputRoomId from "@/components/inputRoomId";
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      featureList: null, // 功能商品列表
      configure: null,
      user: {},
      ticket: "",
      isShowTips: false,
      isShowCloseTips: false,
      isShowRefreshBtn: false,
      cloudQrCode: "",
      cloudQrCodeStage: 0,
      cloudLoginTabs: "accountLogin",
      cloudLoading: false,
      phoneNum: "",
      vCode: "",
      vCodeTime: 0,
      areaCode: 86,
      sessionData: "",
      areaCodeList: countryOptions,
      username: "",
      password: "",
      cloudStatus: 0,
      accountList: {},
      accountLoginStatus: false,
      cloudQrcodeData: null,
      loginsms: {
        //短信登录相关数据
        agentIdx: null, // 代理ipindex
        query: null, // 图片获取的query
        captchaId: null, // 图片id
        imgInfo: null,
        code: "", //s输入的验证码
        showImage: false, // 是否显示图片验证码
      },
    };
  },
  computed: {
    ...mapState({
      isPC: (state) => state.isPC,
      cloud: (state) => state.cloud,
      isElectron: (state) => state.isElectron,
    }),
  },
  components: {
    accountLogin,
    inputRoomId,
  },
  watch: {
    cloudLoginTabs(val) {
      if (val == "qrcodeLogin") {
        this.checkCloudLogin(this.cloudQrcodeData);
      } else {
        clearInterval(this._cloudTimer);
      }
    },
  },
  created() {
    userInfo(null, { notify: false }).then((res) => {
      if (res.code == -2050) {
        localStorage.removeItem("sid");
        this.$router.replace("/login");
      } else {
        this.user = res.data;
        this.ticket = res.data.ticket;
        this.accountList = localStorage["accountList"]
          ? JSON.parse(localStorage["accountList"])
          : {};
        if (
          this.accountList[this.$route.query.ticket] &&
          !this.isAccountExpire(this.accountList[this.$route.query.ticket].timestamp)
        ) {
          this.cloud.user = this.accountList[this.$route.query.ticket].user;
        }
        this.getConfig();
      }
    });
  },
  methods: {
    ...mapActions(["changeLoadingStatus"]),
    isAccountExpire(timestamp) {
      let timeStamp = parseInt((+new Date() - timestamp) / 86400000) >= 7;
      if (timeStamp) {
        return true;
      } else {
        return false;
      }
    },
    getConfig() {
      getConfig(
        {
          ticket: this.ticket,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          const configure = res.data.configure;
          let d = JSON.parse(configure);
          if (this.configure == null) {
            this.configure = d;
          } else {
            Object.assign(this.configure, d);
          }
          this.configure.features = res.data.features;
          this.getFeaturList();
        }
      });
    },
    getFeaturList() {
      getFeatureList(null, { notify: false }).then((res) => {
        if (res.code == 0) {
          const featureList = res.data.featureList;
          this.featureList = {};
          featureList.forEach((val, index) => {
            this.featureList[val.jsonField] = val;
            this.featureList[val.jsonField].isBuy = this.configure.features[
              val.jsonField
            ]
              ? true
              : false;
            this.featureList[val.jsonField].timeRemaining = Math.ceil(
              (this.configure.features[val.jsonField] * 1000 - +new Date()) /
                86400000
            );
            if (this.configure[val.jsonField]) {
              this.configure[val.jsonField] = deepObjectMerge(
                JSON.parse(val.defaultData),
                this.configure[val.jsonField]
              );
            } else {
              this.$set(
                this.configure,
                val.jsonField,
                deepObjectMerge({}, JSON.parse(val.defaultData))
              );
            }
          });
        }
      });
    },
    save() {
      this.changeLoadingStatus(true);
      updateConfig({
        configure: JSON.stringify(this.configure),
        ticket: this.ticket,
      }).then((res) => {
        if (res.code == 0) {
          // this.$message.success("保存配置成功");
          this.changeLoadingStatus(false);
          if (this.user.activated) {
            this.linkToRate();
          } else {
            localStorage.removeItem("guidePage");
            this.$router.replace({
              name: "robotManager",
              params: {
                type: "guide",
              },
            });
          }
        }
      });
    }, // 保存配置
    linkToRate() {
      setGuide({
        guide: 3,
      }).then((res) => {
        if (res.code == 0) {
          localStorage.setItem("guidePage", "/guideRate");
          this.$router.replace({
            path: "/guideRate",
          });
        }
      });
    },
    openDownloadPage() {
      window.open("https://www.xiaohudi.com/download.html");
    },
  },
};
</script>
